export default __webpack_public_path__ + "static/planet-green-right-8ee4a8dcf5d3200ecd4f107519922640.png";